import AuditCriteriaSetDTO from 'models/dto/auditCriteriaDTO';

// PLAN-CTI-081 (spec 7.3): a task or event template's checklist and form read as criteria of a generic set, previewed
// and then added through POST criteria/generic/{setId}/templateimport(/preview).

export class TemplateCriteriaImportRequestDTO {
  taskId: number = 0;

  includeChecklist: boolean = true;

  includeForm: boolean = true;

  // 'AI' | 'Manual' | 'Integration'
  verification: string = 'AI';
}

export class TemplateCriteriaImportRowDTO {
  // 'Checklist' | 'Form'
  source: string = '';

  // 1-based within its source: checklist item n, form question n
  sourceIndex: number = 0;

  sourceName: string | null = null;

  requirement: string = '';

  successCriteria: string | null = null;

  // the criterion's short header (PLAN-CTI-082), from the form question's name where it has one
  columnName: string | null = null;

  requiresComment: boolean = false;

  requiresEvidence: boolean = false;

  // 'New' | 'DuplicateInSet' | 'DuplicateInImport' | 'NotConverted'
  status: string = '';

  // why a row is not added: a skip reason code (Computed, Attachment, Context, Retired, NoText) or the server's text
  reason: string | null = null;

  // a duplicate in the set: the existing criterion's key and state
  existingCriterionKey: string | null = null;

  existingState: string | null = null;

  // a duplicate in the import: the item of the template that wins
  duplicateOfSource: string | null = null;

  duplicateOfSourceIndex: number | null = null;
}

export class TemplateCriteriaImportPreviewDTO {
  templateName: string = '';

  // TaskTypes: Template 2 or EventTemplate 4
  templateTaskType: number = 0;

  rows: TemplateCriteriaImportRowDTO[] = [];

  newCount: number = 0;

  duplicateCount: number = 0;

  notConvertedCount: number = 0;
}

// The apply: the rows as applied and the set after the save, as the editor expects after any write.
export class TemplateCriteriaImportResultDTO {
  preview: TemplateCriteriaImportPreviewDTO | null = null;

  set: AuditCriteriaSetDTO | null = null;
}
